import { PlusIcon } from 'lucide-react'

import { Button } from '@/components/button'

interface Props {
    onClick: () => void
}

export default function EmptyInvitations({ onClick }: Props) {
    return (
        <div className="flex flex-col items-center justify-center py-8">
            <PlusIcon className="w-10 h-10" />
            <h5 className="mb-4">You haven't created invited anyone yet</h5>
            <Button onClick={onClick}>Invite someone</Button>
        </div>
    )
}
